module.exports = __webpack_public_path__ + "img/harlow.f6aab108.jpg";